import { useCallback, useContext, useMemo } from "react";
import StreamsContext from "contexts/StreamsContext";
import FieldTypesContext from "views/components/contexts/FieldTypesContext";
import { useInputs } from "hooks/useInputs";
import useNodeSummaries from "hooks/useNodeSummaries";
const formatNode = (node) => `${node.short_node_id} / ${node.hostname}`;
const useMapKeys = () => {
  const streams = useContext(StreamsContext);
  const streamsMap = useMemo(() => {
    var _a;
    return Object.fromEntries((_a = streams == null ? void 0 : streams.map((stream) => [stream.id, stream])) != null ? _a : []);
  }, [streams]);
  const nodes = useNodeSummaries();
  const inputs = useInputs();
  const fieldTypes = useContext(FieldTypesContext);
  const currentFields = useMemo(() => fieldTypes == null ? void 0 : fieldTypes.currentQuery, [fieldTypes == null ? void 0 : fieldTypes.currentQuery]);
  return useCallback(
    (key, field) => {
      var _a, _b, _c, _d, _e;
      const fieldType = currentFields == null ? void 0 : currentFields.find((type) => type.name === field);
      switch ((_a = fieldType == null ? void 0 : fieldType.type) == null ? void 0 : _a.type) {
        case "node":
          return (nodes == null ? void 0 : nodes[key]) ? formatNode(nodes[key]) : key;
        case "input":
          return (_c = (_b = inputs == null ? void 0 : inputs[key]) == null ? void 0 : _b.title) != null ? _c : key;
        case "streams":
          return (_e = (_d = streamsMap == null ? void 0 : streamsMap[key]) == null ? void 0 : _d.title) != null ? _e : key;
        default:
          return key;
      }
    },
    [currentFields, inputs, nodes, streamsMap]
  );
};
export default useMapKeys;
